import { UserAppContext } from "contexts";
import { useContext } from "react";

const useTimezoneHook = () => {
    const { userProfile } = useContext(UserAppContext);
    return userProfile?.data?.timezone;
    // return {timeZoneHook: GameUserInfoData?.getGameUserInfo?.timezone, refetchTimezone: refetch};
};
export default useTimezoneHook;